import Immutable from 'immutable'

export const ErrorRecord = Immutable.Record({
  message: '',
  path: '',
}, 'Error')

export default function createError({ property_path, ...other }) {
  return new ErrorRecord({
    path: property_path,
    ...other,
  })
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/Error.js